function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import 'react-dates/initialize';
import React from 'react';
import Moment from 'moment';
import { PropTypes } from 'prop-types';
import SingleDatePicker from 'react-dates/lib/components/SingleDatePicker';
import Icon from '../Icon';

var SingleDatePickerWrapper = function SingleDatePickerWrapper(props) {
  var state = props.state,
      onFocusChange = props.onFocusChange,
      customProps = props.customProps,
      onDateChange = props.onDateChange,
      numberOfMonths = props.numberOfMonths,
      renderCalendarInfo = props.renderCalendarInfo,
      phrases = props.phrases,
      readOnly = props.readOnly;
  var internalProps = {
    onDateChange: onDateChange,
    numberOfMonths: numberOfMonths,
    renderCalendarInfo: renderCalendarInfo,
    onFocusChange: onFocusChange
  };
  return /*#__PURE__*/React.createElement(SingleDatePicker, _extends({}, customProps, internalProps, {
    customInputIcon: /*#__PURE__*/React.createElement(Icon, {
      name: "event",
      ariaHidden: false,
      ariaLabel: "Open calendar"
    }),
    inputIconPosition: "after",
    date: state.date,
    focused: state.focused,
    navPrev: /*#__PURE__*/React.createElement(Icon, {
      name: "arrow_left"
    }),
    navNext: /*#__PURE__*/React.createElement(Icon, {
      name: "arrow_right"
    }),
    phrases: phrases,
    horizontalMargin: 0,
    readOnly: readOnly
  }));
};

SingleDatePickerWrapper.propTypes = {
  state: PropTypes.object,
  onFocusChange: PropTypes.func,
  onDateChange: PropTypes.func,
  withPortal: PropTypes.bool,
  numberOfMonths: PropTypes.number,
  renderCalendarInfo: PropTypes.func,
  phrases: PropTypes.object,

  /** Props below are for reference, now handled elsewhere */
  placeholder: PropTypes.string,
  date: PropTypes.instanceOf(Moment),
  focused: PropTypes.bool,
  infoPanelContent: PropTypes.func,
  filters: PropTypes.arrayOf(Object),
  hideKeyboardShortcutsPanel: PropTypes.bool,
  small: PropTypes.bool,
  displayFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  weekDayFormat: PropTypes.string,
  monthFormat: PropTypes.string,
  isOutsideRange: PropTypes.func,
  containerProps: PropTypes.object,
  readOnly: PropTypes.bool,
  renderDayContents: PropTypes.func,
  enableOutsideDays: PropTypes.bool,
  isDayBlocked: PropTypes.func,
  isDayHighlighted: PropTypes.func,
  keepOpenOnDateSelect: PropTypes.bool,
  horizontalMargin: PropTypes.number,
  daySize: PropTypes.number,
  customProps: PropTypes.any
};
SingleDatePickerWrapper.defaultProps = {
  /** Props below are for reference, now handled elsewhere */
  date: null,
  focused: null,
  isOutsideRange: function isOutsideRange() {
    return false;
  },
  filters: [],
  hideKeyboardShortcutsPanel: true,
  displayFormat: 'MM/DD/YYYY'
};
SingleDatePickerWrapper.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SingleDatePickerWrapper",
  "props": {
    "date": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "instanceOf",
        "value": "Moment"
      },
      "required": false,
      "description": ""
    },
    "focused": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "isOutsideRange": {
      "defaultValue": {
        "value": "() => false",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "filters": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "custom",
          "raw": "Object"
        }
      },
      "required": false,
      "description": ""
    },
    "hideKeyboardShortcutsPanel": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "displayFormat": {
      "defaultValue": {
        "value": "'MM/DD/YYYY'",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "func"
        }]
      },
      "required": false,
      "description": ""
    },
    "state": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "onFocusChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onDateChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "withPortal": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "numberOfMonths": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "renderCalendarInfo": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "phrases": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "placeholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Props below are for reference, now handled elsewhere"
    },
    "infoPanelContent": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "small": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "weekDayFormat": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "monthFormat": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "containerProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "readOnly": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "renderDayContents": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "enableOutsideDays": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "isDayBlocked": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "isDayHighlighted": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "keepOpenOnDateSelect": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "horizontalMargin": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "daySize": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "customProps": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    }
  }
};
export default SingleDatePickerWrapper;